export default function ValueProposition() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Leads 100% Vérifiés',
      description: 'Chaque lead est vérifié manuellement avant livraison. Coordonnées complètes, projet détaillé, budget confirmé.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-time-line',
      title: 'Livraison Rapide',
      description: 'Recevez vos leads en moins de 24h. Soyez le premier à contacter vos futurs clients.',
      color: 'from-teal-500 to-teal-600'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Ciblage Géographique',
      description: 'Choisissez votre zone d\'intervention. Leads disponibles dans toute la France.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Prix Transparent',
      description: 'Pas de frais cachés. Payez uniquement pour les leads que vous achetez.',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <section id="value" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pourquoi Choisir AccesLeads ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La solution la plus efficace pour développer votre activité de réparation de fenêtres
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${value.color} rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-teal-600 rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Prêt à Développer Votre Activité ?
          </h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Rejoignez des centaines d'artisans qui développent leur chiffre d'affaires grâce à nos leads qualifiés
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => scrollToSection('demandes')}
              className="bg-white text-blue-600 px-8 py-4 rounded-xl text-lg font-bold hover:bg-gray-100 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
              Voir les Leads Disponibles
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-blue-700 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-blue-800 transition-all border-2 border-white/30 inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-line text-xl"></i>
              Nous Contacter
            </button>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-2 gap-8 mt-12 max-w-2xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">150+</div>
              <div className="text-blue-100">Leads disponibles</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">24/7</div>
              <div className="text-blue-100">Nouveaux leads ajoutés</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}